import BaseComponent from "../../../../baseComponent.js";

export default class TypeOptions extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      type: props.type
    }
  }

  onOptionValueClick(type) {
    this.props.onOptionValueClick(type);
    this.setState({type});
  }

  componentWillReceiveProps(nextProps) {
    this.setState({type: nextProps.type});
  }

  showOptions(ref) {
    let element = this.refs[ref];
    this.props.onOptionClick(element);
  }

  render() {
    return (
      <div>
        <div className='tw-option-container'>
          <div className='t-col single' data-cat='precision' ref="type"
               onClick={() => this.showOptions("typeOptions")} style={{textAlign: 'left', padding: '0 10px'}}>
            Type: {this.state.type}
          </div>
        </div>
        <div className='option-list length' ref="typeOptions"
             style={{width: '168px', height: '74px', overflowY: 'auto'}}>
          <div className="item" onClick={() => this.onOptionValueClick('String')}>String</div>
          <div className="item" onClick={() => this.onOptionValueClick('Number')}>Number</div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/typeOptions.jsx